import { stripHtml } from "../../../shared/strip-html.js";
import consent_styles_module_default from "./consent-styles.module.js";
import { jsx } from "react/jsx-runtime";

//#region src/client/components/shared/ContentArea.tsx
const ContentArea = ({ checkbox = false, contents }) => {
	if (!stripHtml(contents).length) return null;
	return /* @__PURE__ */ jsx("div", {
		className: [consent_styles_module_default.htmlContent, checkbox ? consent_styles_module_default.checkboxLabel : ""].join(" "),
		dangerouslySetInnerHTML: { __html: contents }
	});
};

//#endregion
export { ContentArea };